import { useEffect } from 'react';
import { useRouteMatch, useHistory } from 'react-router';
import { filter, find, isNil } from 'lodash';
import { Terminal } from '../types/graph';
import { useCurrentUser } from '../hooks';

type TerminalFromUrlProps = {
    onChange: (terminal: number | null) => void
};

const TerminalFromUrl = ({ onChange }: TerminalFromUrlProps) => {
    const { params } = useRouteMatch();
    const { currentUser } = useCurrentUser();
    const history = useHistory();

    const terminals = filter(currentUser?.terminals, 'active');

    const slug = (params as any)['slug'] as string;
    const terminal: Terminal | null = find(terminals, ['slug', slug]) ?? null;

    useEffect(() => {
        onChange?.(terminal?.id??null);
    }, [onChange, terminal]);

    useEffect(() => {
        if (isNil(currentUser) || terminal !== null) {
            return;
        }

        if (terminal === null && terminals.length === 1) {
            history.push(`/${terminals[0].slug}`);
            return;
        }

        history.push('/');

    }, [terminal, terminals, currentUser, slug, history])

    return null;
}

export default TerminalFromUrl;